import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {onBeforeUnmount, ref} from 'vue';
import {
    OperatorApplicationShortcutsInstance
} from "~/operatorApplication/ts/service/shortcuts/OperatorApplicationShortcuts";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "ShortcutConfigInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

let model = _useModel<string>(__props, "modelValue");

let disposeRecorder = ref<Function>();

function onFocus() {
    disposeRecorder.value = OperatorApplicationShortcutsInstance.record(shortcut => {
        model.value = isValidShortcut(shortcut) ? shortcut : null;
    });
}

function isValidShortcut(shortcut: string) {
    return shortcut == "Escape" || shortcut.indexOf("+") > 0 || shortcut.match(/F[\d]/);
}

function onBlur() {
    if (disposeRecorder.value) {
        disposeRecorder.value();
        disposeRecorder.value = null;
    }
}

onBeforeUnmount(() => {
    onBlur();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createBlock(_component_el_input, {
    "model-value": _unref(model),
    onFocus: onFocus,
    onBlur: onBlur,
    style: {"width":"15em"},
    placeholder: _unref(__)('Введите сочетание клавиш')
  }, null, 8, ["model-value", "placeholder"]))
}
}

})